export const loadingPhaseDimensionsFor = ({
  hasEvidenceItems,
  isCompactDesktop,
  useStackedNodes,
  visibleProcessNodeCount,
}) => {
  const canvasWidth = useStackedNodes ? 328 : isCompactDesktop ? 780 : 980;
  const canvasHeight = useStackedNodes
    ? (visibleProcessNodeCount ? 610 : 388)
    : isCompactDesktop ? 468 : 500;
  const containerMinHeight = useStackedNodes
    ? (visibleProcessNodeCount ? canvasHeight : 320)
    : isCompactDesktop ? 416 : 440;
  const coreWidth = useStackedNodes ? 236 : isCompactDesktop ? 292 : 340;
  const coreHeight = hasEvidenceItems
    ? (useStackedNodes ? 250 : isCompactDesktop ? 264 : 282)
    : (useStackedNodes ? 230 : isCompactDesktop ? 252 : 276);
  const phaseDetailMaxHeight = hasEvidenceItems
    ? (useStackedNodes ? 88 : isCompactDesktop ? 108 : 122)
    : (useStackedNodes ? 92 : isCompactDesktop ? 104 : 116);
  const evidencePanelMaxHeight = useStackedNodes ? 138 : isCompactDesktop ? 146 : 168;
  const processNodePreviewMaxHeight = useStackedNodes ? 76 : isCompactDesktop ? 88 : 104;
  const connectorGap = useStackedNodes ? 0 : isCompactDesktop ? 36 : 44;
  const centerRadius = useStackedNodes ? "24px" : isCompactDesktop ? "28px" : "32px";
  const haloExtra = useStackedNodes ? 72 : isCompactDesktop ? 96 : 150;
  const dashedExtra = useStackedNodes ? 42 : isCompactDesktop ? 56 : 78;
  const ringExtra = useStackedNodes ? 18 : isCompactDesktop ? 22 : 28;
  const stackedCoreCenterY = hasEvidenceItems ? 164 : 140;
  const coreCenterTop = useStackedNodes && visibleProcessNodeCount
    ? `${stackedCoreCenterY}px`
    : "50%";
  const stackedNodesTop = useStackedNodes && visibleProcessNodeCount
    ? `${stackedCoreCenterY + coreHeight / 2 + 14}px`
    : `calc(50% + ${coreHeight / 2 + 14}px)`;

  return {
    canvasHeight,
    canvasWidth,
    centerRadius,
    connectorGap,
    containerMinHeight,
    coreCenterTop,
    coreHeight,
    coreWidth,
    dashedExtra,
    evidencePanelMaxHeight,
    haloExtra,
    phaseDetailMaxHeight,
    processNodePreviewMaxHeight,
    ringExtra,
    stackedNodesTop,
  };
};
